'use strict'

function _typeof(obj) {
	return (_typeof =
		'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
			? function (obj) {
					return typeof obj
				}
			: function (obj) {
					return obj &&
						'function' == typeof Symbol &&
						obj.constructor === Symbol &&
						obj !== Symbol.prototype
						? 'symbol'
						: typeof obj
				})(obj)
}

function fade(el) {
	var op = 0,
		timer = setInterval(function () {
			op >= 1 && clearInterval(timer)
			el.style.opacity = op
			el.style.filter = 'alpha(opacity=' + 100 * op + ')'
			op += 0.1 * op || 0.1
		}, 25)
}

jQuery(document).ready(function ($) {
	if (1 == $('body').hasClass('desktop')) {
		var controller = new ScrollMagic.Controller()
		new ScrollMagic.Scene({
			triggerElement: '.menu-trigger',
		})
			.setClassToggle('.main-header', 'squish')
			.setPin('.main-header')
			.addTo(controller)
	}

	$('.nav-search i,.nav-search').on('click', function () {
		$('.nav-search').addClass('active')
	})

	$('.nav-search .form-control').on('blur', function () {
		$('.nav-search').removeClass('active')
	})

	$('.navbar-toggler').on('click', function () {
		$('.navbar-collapse').toggleClass('open')
	})

	$(function () {
		var hero = document.getElementsByClassName('page-home-intro-slider')
		if (null !== hero && hero.length > 0) {
			document.documentElement.dataset.scroll = window.pageYOffset
			document.addEventListener('scroll', function (event) {
				document.documentElement.dataset.scroll = window.scrollY
			})
		}
	})
})
;(function () {
	var add_multiple
	new Swiper('.collection-row-swiper', {
		loop: true,
		slidesPerView: 1,
		spaceBetween: 15,
	})

	$(window).on('load', function () {
		$('.promoted-products-box').appendTo('.yotpo-main-widget')
		$('.write-first-question-button').addClass('btn btn-primary')
		$('.write-first-review-button').addClass('btn btn-primary')
	})

	if ((add_multiple = $('.add-multiple')).length > 0) {
		add_multiple.on('click', function () {
			var elData = $(this).data(),
				data = {}

			if (void 0 !== elData.products) {
				data = {
					items: [],
				}
				var products = $(this).data('products').split(','),
					products_ = {}
				for (var k in (products.forEach(function (product) {
					void 0 === products_[product]
						? (products_[product] = 1)
						: (products_[product] += 1)
				}),
				products_))
					data.items.push({
						id: k,
						quantity: products_[k],
					})
			} else if (void 0 !== elData.product && void 0 !== elData.quantity) {
				data = {
					id: elData.product,
					quantity: elData.quantity,
				}
			}

			$.ajax({
				type: 'POST',
				url: '/cart/add.json',
				data: data,
				success: function (data) {
					console.log('success on multiple')
					var $events = Shopify.theme.eventBus
					Shopify.theme.CartService.getCart()
					$events.dispatch($events.types.AddedToCart)
				},
				error: function (response) {
					console.log('error on multiple')
					var $events = Shopify.theme.eventBus
					Shopify.theme.CartService.getCart()
					$events.dispatch($events.types.AddedToCart)
				},
				dataType: 'application/json',
			})
		})
	}
})()
;(function () {
	const openButtons = document.querySelectorAll('[data-cart-open')
	const closeButton = document.querySelector('[data-cart-close')
	const cartDrawer = document.querySelector('[data-cart-drawer]')
	const overlay = document.querySelector('.page-overlay')

	overlay.addEventListener('click', () => {
		document.body.classList.remove('cart-open')
		cartDrawer.classList.remove('open')
		// cartDrawer.setAttribute('aria-hidden', 'true')
	})

	if (openButtons !== null && typeof openButtons !== 'undefined') {
		openButtons.forEach((openButton) => {
			openButton.addEventListener('click', () => {
				document.body.classList.add('cart-open')
				cartDrawer.classList.add('open')
				// cartDrawer.setAttribute('aria-hidden', 'false')
			})
		})
	}

	closeButton.addEventListener('click', () => {
		document.body.classList.remove('cart-open')
		cartDrawer.classList.remove('open')
		// cartDrawer.setAttribute('aria-hidden', 'true')
	})

	if (window.location.hash === '#open-cart') {
		document.body.classList.add('cart-open')
		cartDrawer.classList.add('open')
		// cartDrawer.setAttribute('aria-hidden', 'false')
	}
})()
;(function () {
	var $events = Shopify.theme.eventBus

	$events.on($events.types.AjaxCartRefreshed, function () {
		const cartDrawer = document.querySelector('[data-cart-drawer]')

		document.body.classList.add('cart-open')
		cartDrawer.classList.add('open')
		cartDrawer.setAttribute('aria-hidden', 'false')
	})
})()
;(function () {
	if ($('[data-faq-filter]').length > 0) {
		$.expr[':'].contains = $.expr.createPseudo(function (arg) {
			return function (elem) {
				return $(elem).text().toUpperCase().indexOf(arg.toUpperCase()) >= 0
			}
		})

		$('[data-filter-search-text]').on('keyup', function () {
			if ($(this).val().length > 0) {
				$('[data-filtering]:not(:contains("' + $(this).val() + '"))').addClass(
					'd-none',
				)
				var $found = $('[data-filtering]:contains("' + $(this).val() + '")')
				$found.removeClass('d-none')
				$found.length == 0
					? $('[data-no-result]').removeClass('d-none')
					: $('[data-no-result]').addClass('d-none')
			} else {
				$('[data-filtering]').removeClass('d-none')
				$('article.noResult').addClass('d-none')
			}
		})
	}
})()
;(function () {
	var $events = Shopify.theme.eventBus,
		$cartService = Shopify.theme.CartService,
		$container = $('[cart-free-shipping-notice]')

	if ($container.length > 0) {
		var app = {
			init: function () {
				app.data = $container.data()
				if (_typeof(Shopify.theme.cartOnLoad)) {
					app.check(Shopify.theme.cartOnLoad)
				}
				$events.on($events.types.CartUpdated, function ($data) {
					app.check($cartService.cart)
				})
				$events.on($events.types.AjaxCartRefreshed, function ($data) {
					$container = $('[cart-free-shipping-notice]')
					app.data = $container.data()
					app.check($cartService.cart)
				})
			},
			check: function ($cart) {
				if (app.data.threshold > 0) {
					var cart_price = $cart.total_price / 100,
						excludedProducts = app.data.excludedProducts
					if (excludedProducts.length > 0) {
						cart_price = 0
						$cart.items.forEach(function (item) {
							if (!excludedProducts.includes(item.product_id)) {
								cart_price += item.final_line_price / 100
							}
						})
					}
					app.data.threshold > cart_price
						? $container.html(
								app.data.noticeAlmostPassed.replace(
									'__AMOUNT__',
									(app.data.threshold - cart_price).toFixed(2),
								),
							)
						: $container.html(app.data.noticePassed)
				}
			},
		}
		app.init()
	}
})()
;(function () {
	var sections = document.querySelectorAll('.page-section-collection-row-small.is_swiper')
	if (sections && null != sections && sections.length > 0) {
		sections.forEach(function (section) {
			var container = section.querySelector('.swiper-container')
			if (container && null != container) {
				const nextEL = section.querySelector('.swiper-button-next');
				const prevEL = section.querySelector('.swiper-button-prev')
				const paginationEl = section.querySelector( 'swiper-pagination');
				const swiper = new Swiper(container, {
					centeredSlides: false,
					loop: false,
					slidesPerView: 2,
					spaceBetween: 20,
					navigation: {
						nextEl: nextEL,
						prevEl: prevEL,
					},
					pagination:{
						el: paginationEl
					},
					breakpoints: {
						778: {
							slidesPerView: 3,
						},
						992: {
							slidesPerView: 4,
						},
					},
				})
			}
		})
	}
})()



;(function () {
	var exploreSwipers = document.querySelectorAll('.explore-swiper')
	if (exploreSwipers && exploreSwipers.length > 0) {
		exploreSwipers.forEach(function (exploreSwiper) {
			var nextEL = exploreSwiper.querySelector('.swiper-button-next'),
				prevEL = exploreSwiper.querySelector('.swiper-button-prev')
			new Swiper(exploreSwiper, {
				loop: false,
				slidesPerView: 2,
				spaceBetween: 20,
				navigation: {
					nextEl: nextEL,
					prevEl: prevEL,
				},
				breakpoints: {
				},
			})
		})
	}
})()
;(function () {
	new Swiper('.page-section-intro-slider.has-slides .swiper-container', {
		loop: true,
		slidesPerView: 1,
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	})
})()
;(function () {
	var hero = document.getElementById('shopify-section-page-home-intro-slider')
	if (null != hero && hero.length > 0) {
		document.documentElement.dataset.scroll = 0
		document.addEventListener('scroll', function (event) {
			document.documentElement.dataset.scroll = window.scrollY
		})
	}
})()
;(function () {
	if ($('.template-index').length >= 1) {
		var video = $('#hero-video')[0]
		video.style.opacity = 0
		fade(video)
	}
})
;(function () {
	$('.page-section-media-row').each(function () {
		var row = $(this),
			video = $($(this).find('video'))[0],
			btn = $($(this).find('.btn-play'))
		btn.on('click', function () {
			if (video.paused) {
				btn.fadeOut('fast', function () {
					row.addClass('loaded')
					video.play()
				})
			} else {
				$element.removeClass('loaded')
				video.pause()
				btn.fadeIn('fast')
			}
		})
	})
})()
;(function () {
	var galleryThumbs = new Swiper('.product-thumbs-swiper', {
			spaceBetween: 5,
			slidesPerView: 5,
			width: 400,
			direction: 'horizontal',
			slideToClickedSlide: !0,
		}),
		galleryThumbsFS =
			(new Swiper('.product-main-swiper', {
				spaceBetween: 10,
				thumbs: {
					swiper: galleryThumbs,
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
			}),
			new Swiper('.product-thumbs-swiper-FS', {
				spaceBetween: 5,
				slidesPerView: 5,
				width: 400,
				direction: 'horizontal',
				slideToClickedSlide: !0,
			}))
	new Swiper('.product-main-swiper-FS', {
		spaceBetween: 0,
		slidesPerView: 1,
		thumbs: {
			swiper: galleryThumbsFS,
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	})

	function formatMoney(number, decPlaces, decSep, thouSep) {
		;(decPlaces = isNaN((decPlaces = Math.abs(decPlaces))) ? 2 : decPlaces),
			(decSep = void 0 === decSep ? '.' : decSep),
			(thouSep = void 0 === thouSep ? ',' : thouSep)
		var sign = number < 0 ? '-' : '',
			i = String(
				parseInt((number = Math.abs(Number(number) || 0).toFixed(decPlaces))),
			),
			j = (j = i.length) > 3 ? j % 3 : 0,
			money =
				sign +
				(j ? i.substr(0, j) + thouSep : '') +
				i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, '$1' + thouSep) +
				(decPlaces
					? decSep +
						Math.abs(number - i)
							.toFixed(decPlaces)
							.slice(2)
					: '')
		return (money = money.replace('.00', '')), console.log(money), money
	}
	if (
		($('.swiper-show-fs').on('click', function () {
			$('.product-swiper-FS').addClass('fs-active'),
				$('.product-swiper').addClass('main-hidden'),
				$('body').css('overflow', 'hidden')
		}),
		$('.swiper-FS-close').on('click', function () {
			$('.product-swiper-FS').removeClass('fs-active'),
				$('.product-swiper').removeClass('main-hidden'),
				$('body').css('overflow', 'visible')
		}),
		Shopify.theme.currentProduct)
	) {
		var $events = Shopify.theme.eventBus,
			$variant = Shopify.theme.currentProduct.variants[0],
			product = Shopify.theme.currentProduct,
			$swatches = $('[data-swatch-value]'),
			update_swatch_labels = function (variant) {
				if ($swatches.length > 0 && 'Pack Size' == product.options[1]) {
					var prices = {}
					product.variants.forEach(function (v) {
						prices.hasOwnProperty(v.option1) ||
							(prices[v.option1] = {
								values: [],
								size: 0,
								basePrice: 0,
							})
						var result = /^\d+/gm.exec(v.option2)
						if (null !== result) {
							var size = parseInt(result[0]),
								pack = v.option2.replace(size, '')
							1 == size
								? (prices[v.option1].basePrice = v.price)
								: 's' == pack.charAt(pack.length - 1) &&
									(pack = pack.slice(0, pack.length - 1).trim())
							var discountPrice =
									((v.price - prices[v.option1].basePrice * size) / 100) * -1,
								unitPrice = v.price / 100 / size
							prices[v.option1].values.push({
								size: size,
								price: v.price,
								pack: pack,
								unitPrice: unitPrice,
								discountPrice: discountPrice,
							})
						}
					}),
						prices[$variant.option1].values.forEach(function (value) {
							var label = $(
									'[data-swatch-value][data-pack-size="' +
										value.size +
										'"] label ',
								),
								unitPriceDiv = $(label).find('.label-price'),
								discountDiv = $(label).find('.label-discount')
							discountDiv.removeClass('discounted'),
								1 == value.size
									? discountDiv.text('No Discount')
									: discountDiv
											.text('Save $' + formatMoney(value.discountPrice))
											.addClass('discounted'),
								unitPriceDiv.text(
									'$' + formatMoney(value.unitPrice) + '/' + value.pack,
								)
						})
				}
			}
		update_swatch_labels(),
			$events.on($events.types.OptionsSelected, function ($event) {
				update_swatch_labels($event.detail)
			})
	}
})()
;(function () {
	if (
		($('[related-recipes]').each(function ($e) {
			var _this = this,
				data = $(this).data(),
				url = data.url.replace('tags', data.tags)
			$.get(url, function (res) {
				var temp = $("<div class='d-none'/>")
				temp.html(res),
					temp.find('.swiper-slide').each(function (item) {
						$(this).data('handle') == data.handle && $(this).remove()
					}),
					$(_this).html(temp.html())
				new Swiper('.recipe-swiper', {
					loop: !1,
					slidesPerView: 1,
					spaceBetween: 20,
					pagination: {
						el: '.swiper-pagination',
						clickable: !0,
					},
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
					breakpoints: {
						512: {
							slidesPerView: 1,
						},
						778: {
							slidesPerView: 2,
						},
						992: {
							slidesPerView: 3,
						},
					},
				})
			})
		}),
		1 == $('[blog-filters]').length)
	) {
		var filters = $('[blog-filters]'),
			filter = $(filters.find('select')),
			url = filters.data('url')
		filter.on('change', function () {
			var selected_filters = []
			if (
				(filter.each(function () {
					var option = $($(this).find('option:selected'))
					'all' !== option.data('tag') && selected_filters.push(option.data())
				}),
				selected_filters.length > 0)
			) {
				var tag_string = '/tagged/'
				1 == selected_filters.length
					? (tag_string += selected_filters[0].tag)
					: (tag_string += selected_filters
							.map(function (item) {
								return item.tag
							})
							.join('+')),
					(window.location.href = url + tag_string)
			} else window.location.href = url
		})
	}
})()
;(function () {
	var rotatingBanners = document.querySelectorAll('.rotating-banner-wrap')
	rotatingBanners &&
		rotatingBanners.forEach(function (rotatingBanner) {
			var element,
				elementWidth,
				parentWidth,
				flag,
				banner = rotatingBanner.querySelector('.rotating-banner')
			;(elementWidth = (element = banner).offsetWidth),
				(parentWidth = element.parentElement.offsetWidth),
				(flag = 0),
				setInterval(function () {
					;(element.style.marginLeft = --flag + 'px'),
						elementWidth == -flag && (flag = parentWidth)
				}, 10)
		})
})()

document.addEventListener('DOMContentLoaded', () => {
	var sections = document.querySelectorAll('.page-section-single-swipe')
	sections &&
		null != sections &&
		sections.length > 0 &&
		sections.forEach(function (section) {
			var container = section.querySelector('.swiper-container')
			if (container && null != container) {
				var nextEL = section.querySelector('.swiper-button-next'),
					prevEL = section.querySelector('.swiper-button-prev')
				new Swiper(container, {
					centeredSlides: false,
					loop: !1,
					slidesPerView: 1,
					spaceBetween: 20,
					navigation: {
						nextEl: nextEL,
						prevEl: prevEL,
					},
					breakpoints: {
						512: {
							slidesPerView: 1,
						},
						778: {
							slidesPerView: 1,
						},
						992: {
							slidesPerView: 1,
						},
					},
				})
			}
		})
})
;(function () {
	var galleryThumbs = new Swiper('.product-thumbs-swiper', {
		spaceBetween: 5,
		slidesPerView: 5,
		width: 400,
		direction: 'horizontal',
		slideToClickedSlide: true,
	})

	new Swiper('.product-main-swiper', {
		spaceBetween: 10,
		thumbs: {
			swiper: galleryThumbs,
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	})

	var galleryThumbsFS = new Swiper('.product-thumbs-swiper-FS', {
		spaceBetween: 5,
		slidesPerView: 5,
		width: 400,
		direction: 'horizontal',
		slideToClickedSlide: true,
	})

	new Swiper('.product-main-swiper-FS', {
		spaceBetween: 0,
		slidesPerView: 1,
		thumbs: {
			swiper: galleryThumbsFS,
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	})

	function formatMoney(number, decPlaces, decSep, thouSep) {
		decPlaces = isNaN((decPlaces = Math.abs(decPlaces))) ? 2 : decPlaces
		decSep = void 0 === decSep ? '.' : decSep
		thouSep = void 0 === thouSep ? ',' : thouSep
		var sign = number < 0 ? '-' : ''
		var i = String(
			parseInt((number = Math.abs(Number(number) || 0).toFixed(decPlaces))),
		)
		var j = (j = i.length) > 3 ? j % 3 : 0
		var money =
			sign +
			(j ? i.substr(0, j) + thouSep : '') +
			i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, '$1' + thouSep) +
			(decPlaces
				? decSep +
					Math.abs(number - i)
						.toFixed(decPlaces)
						.slice(2)
				: '')
		money = money.replace('.00', '')
		console.log(money)
		return money
	}

	$('.swiper-show-fs').on('click', function () {
		$('.product-swiper-FS').addClass('fs-active')
		$('.product-swiper').addClass('main-hidden')
		$('body').css('overflow', 'hidden')
	})

	$('.swiper-FS-close').on('click', function () {
		$('.product-swiper-FS').removeClass('fs-active')
		$('.product-swiper').removeClass('main-hidden')
		$('body').css('overflow', 'visible')
	})

	if (Shopify.theme.currentProduct) {
		var $events = Shopify.theme.eventBus
		var $variant = Shopify.theme.currentProduct.variants[0]
		var product = Shopify.theme.currentProduct
		var $swatches = $('[data-swatch-value]')

		var update_swatch_labels = function (variant) {
			if ($swatches.length > 0 && 'Pack Size' == product.options[1]) {
				var prices = {}
				product.variants.forEach(function (v) {
					if (!prices.hasOwnProperty(v.option1)) {
						prices[v.option1] = {
							values: [],
							size: 0,
							basePrice: 0,
						}
					}
					var result = /^\d+/gm.exec(v.option2)
					if (null !== result) {
						var size = parseInt(result[0])
						var pack = v.option2.replace(size, '')
						if (1 == size) {
							prices[v.option1].basePrice = v.price
						} else if ('s' == pack.charAt(pack.length - 1)) {
							pack = pack.slice(0, pack.length - 1).trim()
						}
						var discountPrice =
							((v.price - prices[v.option1].basePrice * size) / 100) * -1
						var unitPrice = v.price / 100 / size
						prices[v.option1].values.push({
							size: size,
							price: v.price,
							pack: pack,
							unitPrice: unitPrice,
							discountPrice: discountPrice,
						})
					}
				})

				prices[$variant.option1].values.forEach(function (value) {
					var label = $(
						'[data-swatch-value][data-pack-size="' + value.size + '"] label ',
					)
					var unitPriceDiv = $(label).find('.label-price')
					var discountDiv = $(label).find('.label-discount')
					discountDiv.removeClass('discounted')
					if (1 == value.size) {
						discountDiv.text('No Discount')
					} else {
						discountDiv
							.text('Save $' + formatMoney(value.discountPrice))
							.addClass('discounted')
					}
					unitPriceDiv.text(
						'$' + formatMoney(value.unitPrice) + '/' + value.pack,
					)
				})
			}
		}

		update_swatch_labels()

		$events.on($events.types.OptionsSelected, function ($event) {
			update_swatch_labels($event.detail)
		})
	}
})()
;(function () {
	$('[related-recipes]').each(function ($e) {
		var _this = this
		var data = $(this).data()
		var url = data.url.replace('tags', data.tags)
		$.get(url, function (res) {
			var temp = $("<div class='d-none'/>")
			temp.html(res)
			temp.find('.swiper-slide').each(function (item) {
				if ($(this).data('handle') == data.handle) {
					$(this).remove()
				}
			})
			$(_this).html(temp.html())
			new Swiper('.recipe-swiper', {
				loop: false,
				slidesPerView: 1,
				spaceBetween: 20,
				pagination: {
					el: '.swiper-pagination',
					clickable: true,
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				breakpoints: {
					512: {
						slidesPerView: 1,
					},
					778: {
						slidesPerView: 2,
					},
					992: {
						slidesPerView: 3,
					},
				},
			})
		})
	})

	if ($('[blog-filters]').length == 1) {
		var filters = $('[blog-filters]')
		var filter = $(filters.find('select'))
		var url = filters.data('url')
		filter.on('change', function () {
			var selected_filters = []
			filter.each(function () {
				var option = $($(this).find('option:selected'))
				if ('all' !== option.data('tag')) {
					selected_filters.push(option.data())
				}
			})
			if (selected_filters.length > 0) {
				var tag_string = '/tagged/'
				if (selected_filters.length == 1) {
					tag_string += selected_filters[0].tag
				} else {
					tag_string += selected_filters
						.map(function (item) {
							return item.tag
						})
						.join('+')
				}
				window.location.href = url + tag_string
			} else {
				window.location.href = url
			}
		})
	}
})()
;(function () {
	var rotatingBanners = document.querySelectorAll('.rotating-banner-wrap')
	if (rotatingBanners) {
		rotatingBanners.forEach(function (rotatingBanner) {
			var banner = rotatingBanner.querySelector('.rotating-banner')
			var element = banner
			var elementWidth = element.offsetWidth
			var parentWidth = element.parentElement.offsetWidth
			var flag = 0
			setInterval(function () {
				element.style.marginLeft = --flag + 'px'
				if (elementWidth == -flag) {
					flag = parentWidth
				}
			}, 10)
		})
	}
})()

document.addEventListener('DOMContentLoaded', () => {
	var sections = document.querySelectorAll('.page-section-single-swipe')
	if (sections && sections.length > 0) {
		sections.forEach(function (section) {
			var container = section.querySelector('.swiper-container')
			if (container) {
				var nextEL = section.querySelector('.swiper-button-next')
				var prevEL = section.querySelector('.swiper-button-prev')
				new Swiper(container, {
					centeredSlides: false,
					loop: false,
					slidesPerView: 1,
					spaceBetween: 20,
					navigation: {
						nextEl: nextEL,
						prevEl: prevEL,
					},
					breakpoints: {
						512: {
							slidesPerView: 1,
						},
						778: {
							slidesPerView: 1,
						},
						992: {
							slidesPerView: 1,
						},
					},
				})
			}
		})
	}
})

//-----------------------------------------------------
// BOF ml-theme.js
//-----------------------------------------------------


/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
!function(e){e.fn.prepareTransition=function(){return this.each(function(){var t=e(this);t.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){t.removeClass("is-transitioning")});var n=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"],i=0;e.each(n,function(e,n){i||(i=parseFloat(t.css(n)))}),0!=i&&(t.addClass("is-transitioning"),t[0].offsetWidth)})}}(jQuery);
window.theme = window.theme || {};



theme.collapsibles = (function() {

    var selectors = {
      trigger: '.collapsible-trigger',
      module: '.collapsible-content',
      moduleInner: '.collapsible-content__inner'
    };

    var classes = {
      hide: 'hide',
      open: 'is-open',
      autoHeight: 'collapsible--auto-height'
    };

    var namespace = '.collapsible';

    var isTransitioning = false;

    function init() {
      
      $(selectors.trigger).each(function() {
        var $el = $(this);
      
        var state = $el.hasClass(classes.open);
        $el.attr('aria-expanded', state);
      });

      // Event listeners (hack for modals)
      $('body, .modal__inner')
        .off(namespace)
        .on('click' + namespace, selectors.trigger, function() {

        if (isTransitioning) {
          return;
        }

        isTransitioning = true;

        var $el = $(this);
        var isOpen = $el.hasClass(classes.open);
        var moduleId = $el.attr('aria-controls');
        var $module = $('#' + moduleId);
        var height = $module.find(selectors.moduleInner).outerHeight();
        var isAutoHeight = $el.hasClass(classes.autoHeight);

        // If isAutoHeight, set the height to 0 just after setting the actual height
        // so the closing animation works nicely
        if (isOpen && isAutoHeight) {
          setTimeout(function() {
            height = 0;
            setTransitionHeight($module, height, isOpen, isAutoHeight);
          }, 0);
        }

        if (isOpen && !isAutoHeight) {
          height = 0;
        }

        $el
          .attr('aria-expanded', !isOpen)
          .toggleClass(classes.open, !isOpen);

        setTransitionHeight($module, height, isOpen, isAutoHeight);
      });
    }

    function setTransitionHeight($module, height, isOpen, isAutoHeight) {
      $module
        .removeClass(classes.hide)
        .prepareTransition()
        .css('height', height)
        .toggleClass(classes.open, !isOpen);

      if (!isOpen && isAutoHeight) {
        var o = $module;
        window.setTimeout(function() {
          o.css('height','auto');
          isTransitioning = false;
        }, 350);
      } else {
        isTransitioning = false;
      }
    }

    return {
      init: init
    };
  })();

document.addEventListener("DOMContentLoaded",()=>{
  theme.collapsibles.init();  
});


//-----------------------------------------------------
// EOF ml-theme.js
//-----------------------------------------------------
